<template>
    <div class="cursor-pointer w-100 mx-2" ref="itemContainer">
        <div class="w-100">
            <Skeletor width="100%" height="100%" class="item-item-img" :style="{height: (Number(getHight)/1.3)+'px' }" />
        </div>
        <Skeletor width="60%" height="15px" class="my-2 ms-0 ms-lg-4 ms-md-2 pt-2"/>
        <Skeletor width="40%" height="15px" class="ms-0 ms-lg-4 ms-md-2"/>
    </div>
</template>

<script setup>
import { Skeletor } from "vue-skeletor";
import "vue-skeletor/dist/vue-skeletor.css";

const itemContainer = ref(null);

const getHight = computed(()=> {
    if (itemContainer.value?.offsetWidth) {
        return itemContainer.value.offsetWidth < 600 ? itemContainer.value.offsetWidth : 500;
        // return itemContainer.value.offsetWidth;
    }
    return 0
})
</script>

<style lang="scss">
.item-item-img {
    min-height: 300px;
}
</style>